<!-- titulo -->
<section class="flex mb-4">
    <div class="flex-1 flex flex-col">
        <span class="span1 text-neutral-600 text-2xl font-semibold font-['Inter'] leading-normal">
            Resumen de los Archivos de Conciliaciones
        </span>
    </div>
</section>

<div class="flex-1" id="dashboardSalesContainer"></div>
<div class="flex-1 mt-6" id="dashboardConciliationsContainer"></div>
